// extracted by mini-css-extract-plugin
export default {"header":"header_header__pau+g","dropdown":"header_dropdown__f9jg1","menuItem":"header_menuItem__vkVTJ","hidden":"header_hidden__XOvy0"};